 <!-- 安祥曲（音乐）详情 -->
<template>
    <div class="detail">
        <topBack>{{topTitle}}</topBack>
        <barF5></barF5>
        <div class="titleRange">
            <div class="title">{{content.audio_title}}</div>
            <div class="titleOther"  v-show="type!='poetry'">{{content.audio_brief}}</div>
            <!-- 图片和音乐播放器 -->
            <div class="titlePic" style="margin-top: 0;">
                <!-- <img src="../../static/img/plowCloudMentor/music.png" alt /> -->
                <audio style="width:80%;height:1.5rem;margin-top:0.6rem" :src="content.audio_url" controls="controls" loop="loop">您的浏览器不支持 audio 标签。</audio>
            </div>
        </div>
        <!-- <div class="content">{{content.audio_content}}</div> -->
<div v-show="type!='poetry'">
	<div class="content" v-html="content.audio_content"></div>
</div>
		<div v-show="type=='poetry'" class="content">
			{{content.audio_brief}}
		</div>
        <div class="blank"></div>
        <barF5></barF5>
        <!-- 底部button -->
        <!-- <footer>
            <Button>{{topTitle}}</Button>
        </footer> -->
    </div>
</template>

<script>
import { fetch } from "../../api/fetch";

import topBack from "../../components/topBack.vue";
import barF5 from "../../components/barF5"; //空隙bar
import Button from "../../components/button"; //返回首頁
export default {
    name: "",
    components: {
        topBack,
        barF5,
        Button
    },
    props: {},
    data() {
        return {
			type:'',
            topTitle:"",
            content: {
                // id: "",
                // audio_title: "安詳之美",
                // other: "～一九八五年七月廿一日講於台北巿",
                // audio_url: "",
                // audio_content:
                //     "耕雲先生出生於一九二四年農曆五月一日天津市。乳名「大有」。幼入私塾，學名「連元」，字「仲三」，十二歲讀完《四書》及《左傳》。 一九四二年隨軍駐西康，依瑪西其安上師習學白教密法，得灌頂為阿奢黎。一九四九年隨軍到台灣，一九八三年秋退休。 先生感於國事，更名為「挽」，在台期間，深痛天涯淪落，海角飄零，乃銳志參禪，於一九七四年桃園龍潭軍中「桶底脫落」，了畢大事。一九八二年應禪學會之請求， 允為導師，為有緣「解粘去縛，抽釘拔楔」，迄二○○○年圓寂，計十八年整，其間歷次所說法要，名曰「安祥禪」 ，印有專輯，弘揚寰宇，頗獲有緣信受奉行，無異佛陀在世。 先生之禪，一掃公案、葛藤，作風平實，法力則不可思議，聆聞開示者，每於言下證入金剛心體，恢復心的原態（本來面目），信乎「以心傳心」 之不誣也。 先生少言身世，謹集所聞片段，由弟子拾綴如上。"
           
		    }
        };
    },
    methods: {
        getMuisc() {
            let url = "",
                { name, id } = this.$route.query;
				this.type=name;
            switch (name) {
                case "frenchp":
                    url = "/news/getSoundDetail";
                    break;
					default:
					url = "/news/getSoundDetail";
					break;
            }
            fetch({
                url: url,
                method: "post",
                data: {
                    id: id,
                    language: 1
                }
            }).then(res => {
                let content = res || {};
				// console.log('content',res);
                content.audio_content =  content.audio_content.replace(/<img/g,'<img style="max-width:100%"');
                content.audio_content =  content.audio_content.replace(/<table /g,'<table style="width:100%"');
                // content.news_content =  content.news_content.replace(/16px/g,'0.85rem');
                this.content = content;
				// console.log('content1',content.audio_content);
            });
        }
    },
    mounted() {
        this.getMuisc();
        this.topTitle = this.$route.query.title;
    }
};
</script>

<style scoped>
.detail {
    background-color: #f5f5f5;
}

.titleRange {
    padding: 1rem 0.64rem;
    background-color: #ffffff;
}

.title {
    font-size: 0.85rem;
    line-height: 1.5rem;
    color: #333333;
    font-weight: 600;
}

.titleOther {
    height: 0.8rem;
    font-size: 0.59rem;
    line-height: 1.49rem;
    color: #999999;
    font-size: 0.8rem;
}
.titlePic {
    margin-top: 1rem;
}
.titlePic img {
    width: 8.32rem;
    height: 5.76rem;
}
.content {
    padding: 0.64rem;
    line-height: 1.5rem;
    color: #666666;
    font-size: 0.69rem;
    text-align: left;
    font-size: 0.85rem;
}

.blank {
    width: 100%;
    height: 3rem;
    background-color: #ffffff;
}
</style>